import isDateBetween from 'utils/is-date-between';
import isEmpty from 'utils/is-empty';
import getContentData from './get-content-data';
export const PROMOTIONS = 'promotions_v2';
export const ALL_STORES = 'All';

export const getProductPromo = async ({ correlationId, log }) => {
  const { data: promotions } = await getContentData({
    id: PROMOTIONS,
    correlationId,
    log,
  });
  const promotionsByStore = {};
  for (const promotion of promotions) {
    const productPromoBySku = {};
    const productPromoByCategory = {};
    const {
      product_promotions: productPromotions,
      category_promotions: categoryPromotions,
      title,
    } = promotion;

    for (const productPromotion of productPromotions) {
      const {
        start_date: startDate,
        end_date: endDate,
        promotion_label: label,
        text_transform: textTransform = 'uppercase',
        products,
      } = productPromotion;
      if (isDateBetween(startDate, endDate)) {
        for (const sku of products.skus) {
          productPromoBySku[sku] = { label, textTransform };
        }
      }
    }
    for (const categoryPromotion of categoryPromotions) {
      const {
        start_date: startDate,
        end_date: endDate,
        promotion_label: label,
        text_transform: textTransform = 'uppercase',
        category,
      } = categoryPromotion;
      if (isDateBetween(startDate, endDate)) {
        productPromoByCategory[category.toLowerCase()] = {
          label,
          textTransform,
        };
      }
    }
    if (!isEmpty(productPromoBySku) || !isEmpty(productPromoByCategory)) {
      promotionsByStore[title.toLowerCase()] = {
        productPromoBySku,
        productPromoByCategory,
      };
    }
  }
  return promotionsByStore;
};
